export const isSandbox = process.env.REACT_APP_ENV_TYPE === 'STAGING';
export const isDev = process.env.REACT_APP_ENV_TYPE === 'DEV';
export const isProd = process.env.REACT_APP_ENV_TYPE === 'PROD';
export const trackingId = process.env.REACT_APP_GOOGLE_ANALYTICS || '';
